import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './components/Register';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import IframeComponent from './components/IframeComponent';
// import Notification from './components/Notification';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot_password" element={<ForgotPassword />} /> 
        <Route path="/" element={<IframeComponent />} />
        {/* <Route path="/" element={<Notification />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
